var $b4c4686e78dd56ff$exports = {};
$b4c4686e78dd56ff$exports = {
    "alert": `V\xfdstraha`,
    "dismiss": `Odstranit`
};


export {$b4c4686e78dd56ff$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
